module.exports = __webpack_public_path__ + "static/media/0224_IMG_LE_SOL_LEGNI_WALNUT.4bea403b.png";